import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const InteractiveToolIcon: React.FC<Props> = ({
  color,
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 30)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M4.733 18.877A3.657 3.657 0 0 1 1 15.301V4.575A3.657 3.657 0 0 1 4.733 1h20.533a3.657 3.657 0 0 1 3.733 3.575v10.726a3.479 3.479 0 0 1-.932 2.365" />
      <path d="m14.699 29.002-4.587-6.116a1.828 1.828 0 0 1-.06-2.11h0a1.828 1.828 0 0 1 2.616-.448l2.025 1.519V10.235a1.788 1.788 0 0 1 1.793-1.788h0a1.788 1.788 0 0 1 1.788 1.788v7.151l4.975 1.106a3.575 3.575 0 0 1 2.785 3.814l-.609 6.7Z" />
    </SVG>
  );
};
